/** 사주 정보 입력 (DEV_SPEC 4.1 「봐주세요」, 4.8 나 탭). 서버 services/birth.js 의 validateBirth 와 짝입니다 */
export const EMPTY_BIRTH = {
    calendarType: 'solar',
    birthDate: '',
    isLeapMonth: false,
    birthTime: '',
    timeUnknown: false,
    // 'female' | 'male' | 'none'(말 안 할래요) | null(아직 안 고름). 선택이라 안 골라도 저장됩니다
    gender: null,
};

/** 「알려주기」를 켤지. 날짜가 있고, 시간을 적었거나 「몰라요」를 골랐어야 합니다 */
export function isBirthComplete(birth) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(birth.birthDate)) {
        return false;
    }
    return birth.timeUnknown || /^\d{2}:\d{2}$/.test(birth.birthTime);
}

/** 서버로 보낼 모양. 시간 모름이면 시간을 비우고, 윤달은 음력일 때만 남깁니다 */
export function toBirthPayload(birth) {
    return {
        calendarType: birth.calendarType,
        birthDate: birth.birthDate,
        isLeapMonth: birth.calendarType === 'lunar' && birth.isLeapMonth,
        birthTime: birth.timeUnknown ? null : birth.birthTime,
        timeUnknown: birth.timeUnknown,
        gender: birth.gender === 'female' || birth.gender === 'male' ? birth.gender : null,
    };
}
